import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <section id='footer'>
      <footer className="footer-main"> &copy; 2022 Designed & Built By Sunny Chandra </footer>
    </section>
  )
}

export default Footer